<!--
  說明：首頁特色機種的選單
  特色機種父元件 themes/frontend/src/modules/home/Showcase.vue
-->

<template>
  <div class="header" @click="onClick">
    <h1 v-if="$slots.default">
      <slot />
    </h1>
    <div v-if="$slots.menu" class="menu">
      <slot name="menu" />
    </div>
    <div v-if="$slots.submenuseries" class="">
      <slot name="submenuseries">
        <!-- pc版選單模版-依排氣量 -->
      </slot>
    </div>
    <div v-if="$slots.submenustyles" class="">
      <slot name="submenustyles">
        <!-- pc版選單模版-依生活型態 -->
      </slot>
    </div>
    <div v-if="$slots['mobile-menu']" class="mobile-menu">
      <slot name="mobile-menu">
        <!-- md版選單模版(目前無帶入內容) -->
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    verbose: Boolean,
  },
  data() {
    return {
      domRact: undefined,
      offset: 0,
    }
  },
  mounted() {
    if (this.$el.classList.contains('sticky') && typeof window.Stickyfill === 'object') {
      window.Stickyfill.addOne(this.$el)
    }
  },
  methods: {
    onClick(event) {
      if (event.target.classList.contains('item')) {
        $(document.documentElement).animate(
          {
            scrollTop: $(this.$el).offset().top + 'px',
          },
          500
        )
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
$colorActive = #27A7E1

.header
  padding-top 1.5rem
  padding-bottom 1.5rem
  background white
  font-weight 900
  white-space nowrap
  user-select none
  &.sticky
    position sticky
    position -webkit-sticky
    top 60px
    z-index 190
    @media (max-width 767px)
      display none
  h1
    margin 0 50px 0 0
    flex-grow 0
    flex-shrink 0
    font-weight bold
    text-align center
    + *
      margin-left auto
    &:last-child
      margin-right 0
</style>
